import React from "react";
import { Button, Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

export const DeleteConfirmDialog = (props) => {
  const { open, handleDelete, message, handleConfirm } = props;
  return (
    <Dialog open={open}>
      <DialogContent>
        <Typography variant="h6">{message} </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} color="primary" autoFocus>
          Cancel
        </Button>
        <Button
          onClick={() => {
            handleConfirm();
            handleDelete();
          }}
          color="secondary"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
